import React from 'react';
import { Link } from 'react-router-dom';
import { useCookieConsent } from './useCookieConsent';

const wrapperStyle = {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 9999,
    background: '#1f2937',
    color: '#f9fafb',
    padding: '16px 24px',
    boxShadow: '0 -2px 12px rgba(0, 0, 0, 0.3)',
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
    fontSize: 14,
    lineHeight: 1.5,
};

const textStyle = { flex: '1 1 320px', maxWidth: 720 };

const buttonRowStyle = { display: 'flex', gap: 8, flexShrink: 0 };

const baseButton = {
    border: 'none',
    borderRadius: 4,
    padding: '8px 16px',
    fontSize: 14,
    cursor: 'pointer',
    fontWeight: 500,
};

const acceptStyle = { ...baseButton, background: '#3b82f6', color: '#fff' };
const rejectStyle = { ...baseButton, background: 'transparent', color: '#f9fafb', border: '1px solid #6b7280' };
const linkStyle = { color: '#93c5fd', textDecoration: 'underline' };

function CookieConsent() {
    const { status, accept, reject } = useCookieConsent();

    if (status !== 'pending') return null;

    return (
        <div role="dialog" aria-label="Cookie consent" style={wrapperStyle}>
            <div style={textStyle}>
                We use browser storage to keep you signed in and remember your preferences. With your consent, we may
                also enable optional analytics in the future to improve the product. See our{' '}
                <Link to="/privacy-policy" style={linkStyle}>
                    Privacy Policy
                </Link>{' '}
                for details, including how to request access or deletion of your personal data.
            </div>
            <div style={buttonRowStyle}>
                <button type="button" onClick={reject} style={rejectStyle}>
                    Reject optional
                </button>
                <button type="button" onClick={accept} style={acceptStyle}>
                    Accept all
                </button>
            </div>
        </div>
    );
}

export default CookieConsent;
